import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LookupItemStruct } from '@shared/services/structs/motor-fiscal/lookup-item.struct';

/**
 * Seção "Configurações avançadas" da aba Totais.
 * Réplica estrutural da seção de regra das demais abas (cabeçalho com botão
 * "Personalizar fórmulas"), com os 4 indicadores que afetam o total da nota.
 */
@Component({
    selector: 'app-totais-configuracoes-avancadas-section',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatIconModule, MatButtonModule, MatBadgeModule, MatTooltipModule],
    templateUrl: './configuracoes-avancadas-section.component.html',
    styleUrl: './configuracoes-avancadas-section.component.css',
})
export class ConfiguracoesAvancadasSectionComponent implements OnChanges {
    @Input({ required: true }) form!: FormGroup;
    @Input() personalizadasCount = 0;
    /** Tributo PIS ativo na natureza — habilita "indSomaPisst". */
    @Input() pisAtivo = false;
    /** Tributo COFINS ativo na natureza — habilita "indSomaCofinsst". */
    @Input() cofinsAtivo = false;
    /** Aba de ICMS (ICMS ou ICMS SN, conforme o regime) ativa — habilita "indDeduzDeson". */
    @Input() icmsOuSnAtivo = false;
    @Input() indicadoresComposicaoTotalItem: LookupItemStruct[] = [];
    @Input() indicadoresDeducaoDesoneracao: LookupItemStruct[] = [];
    @Input() indicadoresComposicaoTotalPisSt: LookupItemStruct[] = [];
    @Input() indicadoresComposicaoTotalCofinsSt: LookupItemStruct[] = [];
    @Input() tiposOperacaoVeiculo: LookupItemStruct[] = [];
    @Input() regimesEspeciaisIssqn: LookupItemStruct[] = [];
    @Output() personalizar = new EventEmitter<void>();

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['form'] || changes['pisAtivo'] || changes['cofinsAtivo'] || changes['icmsOuSnAtivo']) {
            this.sincronizarHabilitacao();
        }
    }

    private sincronizarHabilitacao(): void {
        if (!this.form) return;
        this.aplicarHabilitado('indSomaPisst', this.pisAtivo);
        this.aplicarHabilitado('indSomaCofinsst', this.cofinsAtivo);
        this.aplicarHabilitado('indDeduzDeson', this.icmsOuSnAtivo);
    }

    private aplicarHabilitado(nomeControle: string, habilitado: boolean): void {
        const control = this.form.get(nomeControle);
        if (!control) return;
        if (habilitado && control.disabled) {
            control.enable({ emitEvent: false });
        } else if (!habilitado && control.enabled) {
            control.disable({ emitEvent: false });
        }
    }

    public get tooltipPisSt(): string {
        return this.pisAtivo ? '' : 'Habilite o tributo PIS para configurar este indicador.';
    }

    public get tooltipCofinsSt(): string {
        return this.cofinsAtivo ? '' : 'Habilite o tributo COFINS para configurar este indicador.';
    }

    public get tooltipDeduzDeson(): string {
        return this.icmsOuSnAtivo ? '' : 'Habilite o ICMS (ou ICMS SN) para configurar este indicador.';
    }
}
